var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { BuildStatus } from '../enums/build-status';
var BuildStatusPipe = /** @class */ (function () {
    function BuildStatusPipe() {
    }
    BuildStatusPipe.prototype.transform = function (status) {
        switch (status) {
            case BuildStatus.ReadyToBuild:
                return 'New';
            case BuildStatus.InUserBuild:
                return 'In User Build';
            case BuildStatus.Research:
                return 'Queued for Assignment';
            case BuildStatus.Input:
                return 'Build';
            case BuildStatus.Comparison:
                return 'Comparison';
            case BuildStatus.Approval:
                return 'Approval';
            case BuildStatus.Amend:
                return 'Amend';
            case BuildStatus.Live:
                return 'Live';
            case BuildStatus.Complete:
                return 'Complete';
            default:
                return 'N/A';
        }
    };
    BuildStatusPipe = __decorate([
        Pipe({ name: 'buildStatus' })
    ], BuildStatusPipe);
    return BuildStatusPipe;
}());
export { BuildStatusPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtc3RhdHVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYnVpbGQtc3RhdHVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLE9BQU8sRUFBRSxJQUFJLEVBQWlCLE1BQU0sZUFBZSxDQUFDO0FBQ3BELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSx1QkFBdUIsQ0FBQztBQUdwRDtJQUFBO0lBeUJBLENBQUM7SUF4QlUsbUNBQVMsR0FBaEIsVUFBaUIsTUFBbUI7UUFDaEMsUUFBUSxNQUFNLEVBQUU7WUFDWixLQUFLLFdBQVcsQ0FBQyxZQUFZO2dCQUN6QixPQUFPLEtBQUssQ0FBQztZQUNqQixLQUFLLFdBQVcsQ0FBQyxXQUFXO2dCQUN4QixPQUFPLGVBQWUsQ0FBQztZQUMzQixLQUFLLFdBQVcsQ0FBQyxRQUFRO2dCQUNyQixPQUFPLHVCQUF1QixDQUFDO1lBQ25DLEtBQUssV0FBVyxDQUFDLEtBQUs7Z0JBQ2xCLE9BQU8sT0FBTyxDQUFDO1lBQ25CLEtBQUssV0FBVyxDQUFDLFVBQVU7Z0JBQ3ZCLE9BQU8sWUFBWSxDQUFDO1lBQ3hCLEtBQUssV0FBVyxDQUFDLFFBQVE7Z0JBQ3JCLE9BQU8sVUFBVSxDQUFDO1lBQ3RCLEtBQUssV0FBVyxDQUFDLEtBQUs7Z0JBQ2xCLE9BQU8sT0FBTyxDQUFDO1lBQ25CLEtBQUssV0FBVyxDQUFDLElBQUk7Z0JBQ2pCLE9BQU8sTUFBTSxDQUFDO1lBQ2xCLEtBQUssV0FBVyxDQUFDLFFBQVE7Z0JBQ3JCLE9BQU8sVUFBVSxDQUFDO1lBQ3RCO2dCQUNJLE9BQU8sS0FBSyxDQUFDO1NBQ3BCO0lBQ0wsQ0FBQztJQXhCUSxlQUFlO1FBRDNCLElBQUksQ0FBQyxFQUFFLElBQUksRUFBRSxhQUFhLEVBQUUsQ0FBQztPQUNqQixlQUFlLENBeUIzQjtJQUFELHNCQUFDO0NBQUEsQUF6QkQsSUF5QkM7U0F6QlksZUFBZSJ9